/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'profile': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M768 384c0-160-128-288-288-288S192 224 192 384c0 108.8 57.6 201.6 147.2 249.6-121.6 48-214.4 153.6-240 288-3.2 16 6.4 35.2 25.6 38.4h3.2c16 0 28.8-9.6 32-25.6C188.8 784 320 675.2 473.6 672h6.4c160 0 288-128 288-288zm-512 0c0-124.8 99.2-224 224-224s224 99.2 224 224c0 121.6-99.2 220.8-220.8 224h-9.6C352 604.8 256 505.6 256 384zm640 320H640c-19.2 0-32 12.8-32 32v192c0 19.2 12.8 32 32 32h256c19.2 0 32-12.8 32-32V736c0-16-12.8-32-32-32zm-32 192H672V768h192v128z" _fill="#666"/><path pid="1" d="M736 864h32c19.2 0 32-12.8 32-32s-12.8-32-32-32h-32c-19.2 0-32 12.8-32 32s16 32 32 32z" _fill="#666"/>'
  }
})
